export default "__VITE_ASSET__DZWJXOqs__"